export interface BusinessResource {
  id: number;
  type: 'material' | 'human' | 'financial';
  name: string;
  cost: number;
  benefit: number;
  description: string;
}

export interface BusinessDecision {
  id: number;
  situation: string;
  options: {
    id: number;
    text: string;
    impact: {
      customers: number;
      money: number;
      teamHappiness: number;
    };
  }[];
}

export interface BusinessGameState {
  businessName: string;
  businessType: 'store' | 'service' | 'food';
  money: number;
  customers: number;
  teamHappiness: number;
  resources: BusinessResource[];
  decisions: BusinessDecision[];
  currentDecisionIndex: number;
  score: number;
  timeLeft: number;
  isGameOver: boolean;
  gameStarted: boolean;
  achievements: Achievement[];
  bestStreak: number;
  currentStreak: number;
  level: number;
  lessons: {
    id: string;
    title: string;
    content: string;
    completed: boolean;
  }[];
}

export interface Achievement {
  id: string;
  title: string;
  description: string;
  condition: (state: BusinessGameState) => boolean;
  points: number;
  earned: boolean;
}

export const INITIAL_STATE: BusinessGameState = {
  businessName: '',
  businessType: 'store',
  money: 1000,
  customers: 0,
  teamHappiness: 100,
  resources: [],
  decisions: [],
  currentDecisionIndex: 0,
  score: 0,
  timeLeft: 300, // 5 minutos
  isGameOver: false,
  gameStarted: false,
  achievements: [],
  bestStreak: 0,
  currentStreak: 0,
  level: 1,
  lessons: [
    {
      id: 'leadership',
      title: 'Liderazgo Básico',
      content: 'Un buen líder escucha a su equipo y toma decisiones considerando a todos.',
      completed: false
    },
    {
      id: 'customer_service',
      title: 'Servicio al Cliente',
      content: 'Los clientes felices son la base de un negocio exitoso.',
      completed: false
    },
    {
      id: 'resource_management',
      title: 'Gestión de Recursos',
      content: 'Administra bien tus recursos para hacer crecer tu negocio.',
      completed: false
    }
  ]
};
